import {Component, Inject, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {BehaviorSubject, combineLatest, Observable, Subscription} from 'rxjs';
import {debounceTime, filter, map, publishReplay, refCount, switchMap, take, tap} from 'rxjs/operators';
import {AuthCodeResolver, AuthService, ErrorUtils, UserAuthService, UserService} from '@lifeislife/lifeislife-domain';
import {ActivatedRoute, Router} from '@angular/router';
import {DOCUMENT, Location} from '@angular/common';
import {OAuthEvent, OAuthService} from 'angular-oauth2-oidc';
import {LoginRouteService} from './login-route.service';

@Component({
  selector: 'cf-login-route',
  templateUrl: './login-route.component.html',
  styleUrls: ['./login-route.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginRouteComponent implements OnInit, OnDestroy {


  showItsme = false;
  itsmeAvaialable = true;
  showMail = true;
  showPassword = true;

  authenticating$: Observable<boolean>;
  recovering$: Observable<boolean>;

  error?: string;


  private subscription: Subscription;


  constructor(
    public loginRouteService: LoginRouteService,
    private userAuthService: UserAuthService,
    private authService: AuthService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    @Inject(DOCUMENT)
    private document: Document,
    private authCodeResolver: AuthCodeResolver,
    private oauthService: OAuthService,
  ) {
  }

  ngOnInit(): void {
    this.subscription = new Subscription();
    //
    const queryparams = this.route.snapshot.queryParamMap;
    const authCodeSubscription = this.authCodeResolver.exchangeToken$(queryparams).pipe(
      filter(c => c != null),
      switchMap(auth => this.userAuthService.authenticate$(auth, true, true)),
    ).subscribe(u => this.onAuthenticated(),
      e => this.onAuthCodeExchangeError(e));
    this.subscription.add(authCodeSubscription);

    const redirectUrl = queryparams.get('redirectUrl');
    if (redirectUrl) {
      this.loginRouteService.redirectUrl = redirectUrl;
    }

    this.authenticating$ = combineLatest([
      this.loginRouteService.recoveringSession$,
      this.authService.getState$().pipe(map(s => s.status === 'authenticating')),
    ]).pipe(
      map(r => r[0] || r[1]),
      publishReplay(1), refCount(),
    );

    const errorsSubscription = this.authService.getState$().pipe(
      debounceTime(200),
      take(1), // Only display first error if redirected to login
      filter(s => s.status === 'deauthenticated'),
      map(s => s.errorMessage),
      filter(s => s != null),
    ).subscribe(error => this.error = error);
    this.subscription.add(errorsSubscription);


    const authenticatedSubscription = this.userAuthService.state$.pipe(
      filter(s => s.status === 'authenticated'),
    ).subscribe(() => this.onAuthenticated());
    this.subscription.add(authenticatedSubscription);

    this.itsmeAvaialable = this.oauthService.clientId != null && this.oauthService.loginUrl != null
      && this.oauthService.clientId !== '' && this.oauthService.loginUrl !== '';
    this.oauthService.events
      .subscribe(a => this.handleOauthEvent(a));

  }


  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private onAuthenticated() {
    this.loginRouteService.redirectOnLoggedIn();
  }

  private onAuthCodeExchangeError(error: any) {
    this.loginRouteService.recoverSessionError = error.message;

    this.router.navigate(['/login'], {
      queryParams: {
        authCode: undefined,
        authError: undefined,
      },
      replaceUrl: true,
    });
  }


  private handleOauthEvent(a: OAuthEvent) {
    if (a.type === 'silent_refresh_error') {
      this.oauthService.logOut(true);
      this.loginRouteService.recoveringSession$.next(false);
    } else if (a.type === 'silent_refresh_timeout') {
      console.warn(`Silent refresh timeouted - disabling itsme`);
      this.itsmeAvaialable = false;
    } else if (a.type === 'discovery_document_load_error') {
      console.warn(`Discovery dociument load error - disabling itsme`);
      this.itsmeAvaialable = false;
    } else if (a.type === 'discovery_document_loaded') {
      this.itsmeAvaialable = true;
    }
  }
}
